<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'TechCategoryCenter', to: { path: '/tech-category' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>技術類別</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toTechCategoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增技術類別</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <TechCategoryCenterTable></TechCategoryCenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TechCategoryCenterTable from '@/views/E-8__TechCategory/c/TechCategoryCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    TechCategoryCenterTable,
  },
  created() {
    this.clear();
    this.getTechnologyCategoryList();
  },
  methods: {
    ...mapActions('technologycategory', {
      getTechnologyCategoryList: 'find',
      clear: 'clear',
    }),
    toTechCategoryCreate() {
      this.$router.push('/tech-category/create');
    },
  },
};
</script>

<style></style>
